import wizardRoutes from './wizard';
import Contact from "../components/wizard/Contact";
import EmailSent from "../components/wizard/EmailSent";

export default [
    ...wizardRoutes,
    {
        path: "/contact",
        name: "contact",
        component: Contact,
    },
    {
        path: "/email-sent",
        name: "email-sent",
        component: EmailSent
    },
    {
        path: '*',
        redirect: { name: 'applications' }
    }
];

